import React from 'react';
import { SectionHeader } from '../../../common';
import { P } from '../../../../components/Typography';
import { WithTranslation, withTranslation } from 'react-i18next';

type NoTransactionsProps = WithTranslation

const NoTransactions = (
    {
        t,
    }: NoTransactionsProps
) => (<div>
    <SectionHeader>
        {t('customers.customer.no_transactions.title')}
    </SectionHeader>
    <P>{t('customers.customer.no_transactions.body')}</P>
</div>);

export default withTranslation()(NoTransactions);
